// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K5i0jyoik2QzFJ {
  margin-top: var(--ds-space-500, 40px);
}
.nxtUxOb8qy7o_L {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: H2wN2UPj8MbaR_;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 80px;
  height: 12px;
  margin-top: var(--ds-space-200, 16px);
  margin-bottom: var(--ds-space-150, 12px);
}
@keyframes H2wN2UPj8MbaR_ {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .nxtUxOb8qy7o_L {
    animation: none;
  }
}
.oTiPvyNX0A6qrR {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: H2wN2UPj8MbaR_;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 80px;
  height: 20px;
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-150, 12px);
}
@keyframes H2wN2UPj8MbaR_ {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .oTiPvyNX0A6qrR {
    animation: none;
  }
}
.LQkhgXr0Q5OXw9 {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: H2wN2UPj8MbaR_;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 100px;
  margin-top: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-150, 12px);
}
@keyframes H2wN2UPj8MbaR_ {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .LQkhgXr0Q5OXw9 {
    animation: none;
  }
}
.bAN0ZicO9JWMaR {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: H2wN2UPj8MbaR_;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 120px;
  height: 20px;
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-150, 12px);
}
@keyframes H2wN2UPj8MbaR_ {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .bAN0ZicO9JWMaR {
    animation: none;
  }
}
`, ""]);
// Exports
export var skeletonWrapper = `K5i0jyoik2QzFJ`;
export var skeletonSectionTitle = `nxtUxOb8qy7o_L`;
export var shimmer = `H2wN2UPj8MbaR_`;
export var skeletonPopoverOption = `oTiPvyNX0A6qrR`;
export var skeletonColorSection = `LQkhgXr0Q5OXw9`;
export var skeletonButlerOption = `bAN0ZicO9JWMaR`;
export default ___CSS_LOADER_EXPORT___;
